import { Nullable } from './Nullable'

export enum InvoiceStatus {
  Cancelled = 'CANCELLED',
  Open = 'OPEN',
  Outdated = 'OUTDATED',
  Paid = 'PAID',
}

export type Invoice = {
  id: string
  paymentDueDate: string
  paymentReceivedDate: string
  status: Nullable<InvoiceStatus>
  provider: 'BFS' | 'STRIPE'
  totalAmountToBePaid: string
  amountRemainingToBePaid: string
  amountAlreadyPaid: string
  url: string
  invoicePaymentDetailsResult: {
    recipientName: string
    bankName: string
    iban: string
    bic: string
    paymentTitle: string
  }
}
